/* eslint-disable */
import { helpers as H } from './helpers';
import useApi from '@/lib/api/useApi';

const downloadFile = (typeOrUrl: string, key?: string, fileName?: string) => {
  const _fileName = fileName
    ? fileName
    : (fileName = `${H.hash(typeOrUrl)}.pdf`);
  const apiInstance = useApi();
  return apiInstance.download(typeOrUrl, key as string).then((resp) => {
    if (resp.success && resp.data) {
      const blobUrl = URL.createObjectURL(resp.data);
      const link = document.createElement('a');
      link.setAttribute('style', 'display: none');
      link.href = blobUrl;
      link.download = _fileName;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(blobUrl);
      link.remove();
    }

    return resp;
  });
};

export { downloadFile };
